import { useState } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import MarqueeBar from "../components/MarqueeBar";
import Work from "../components/Work";
import ProjectModal from "../components/ProjectModal";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";

const Home = () => {
  const [active, setActive] = useState(null);

  return (
    <div className="paper-grain" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <MarqueeBar />
        <About />
        <Work onOpen={setActive} />
        <MarqueeBar inverted />
        <Testimonials />
        <Contact />
      </main>
      <ProjectModal project={active} onClose={() => setActive(null)} />
    </div>
  );
};

export default Home;
